import { TriangleAlert } from "lucide-react";
import { RAID_ROLE_ICONS } from "@/shared/lib/roleIcons";
import type { RaidRole } from "@/shared/lib/roles";
import { cn } from "@/shared/lib/utils";
import { classColorStyle } from "@/shared/lib/wowClass";
import type { SetupPlayer } from "../setup.types";

// Shared inner content for every player chip/row/cell in the setup feature: a left icon
// (warning triangle when class/role is missing, otherwise the role icon), the class-colored
// name, and a "Stand-in" badge. Renders as a fragment so each caller supplies its own outer
// chrome (card div, sticky th, restore button, …) and layout classes.
export function PlayerLabel({
  player,
  iconLabel,
  nameClassName,
  badgeClassName,
}: {
  player: SetupPlayer;
  iconLabel?: string;
  nameClassName?: string;
  badgeClassName?: string;
}) {
  const unassigned = !player.wowClass || !player.raidRole;
  const RoleIcon = player.raidRole
    ? RAID_ROLE_ICONS[player.raidRole as RaidRole]
    : null;

  return (
    <>
      {unassigned ? (
        // Status color exception: must read as a warning in any theme.
        <TriangleAlert
          className="size-4 shrink-0 text-amber-500"
          aria-label={iconLabel}
        />
      ) : (
        RoleIcon && (
          <RoleIcon className="size-4 shrink-0 text-muted-foreground" />
        )
      )}
      <span
        className={cn("font-medium", nameClassName)}
        style={classColorStyle(player.wowClass)}
      >
        {player.name}
      </span>
      {player.kind === "stand_in" && (
        <span
          data-capture-nowrap
          className={cn(
            "rounded bg-muted text-muted-foreground",
            badgeClassName,
          )}
        >
          Stand-in
        </span>
      )}
    </>
  );
}
